import styled from 'styled-components'

export const ValidationErrorMessage = styled.small.attrs({
  className: 'form-text'
})`
  color: ${({ theme }) => theme.colors.dangerColor};
`
